import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { CSVStatusHeading, UserInviteMap, UserValidationState, UserValidationType } from "src/common";
import { Icon } from "src/components";
import _ from "lodash";

type AllProps = {
  csv_data_hash: UserInviteMap;
  validation_state: UserValidationType;
  collection: string[];
  deleteFunction: Function;
};

// Description: Displays the different tables of the CSV upload card. (Valid, Invalid, Duplicate, etc)
function CSVInvitesDisplayComponent(props: AllProps) {
  const { csv_data_hash, validation_state, collection, deleteFunction } = props;
  const heading_text = CSVStatusHeading[validation_state];
  const heading = collection.length === 1 ? heading_text.replace("Accounts", "Account") : heading_text;

  return <div className="table-display">
    <Row className="header-card-row ">
      <h5 className="m-0">{`${collection.length} ${heading}`}</h5>
    </Row>
    <div className="table-body">
      {_.map(collection, (user_id: string, index: number) => {
        const _user = csv_data_hash[user_id];
        const is_delete = validation_state !== UserValidationState.invalid && validation_state !== UserValidationState.duplicate;
        return <Row key={index}>
        <Col xs={7}>
          <p className="semi-bold">{`${_user.first_name} ${_user.last_name}`}</p>
          <p>{user_id}</p>
        </Col>
        <Col xs={4}>
          <p className="m-0">{_user.department}</p>
        </Col>
        {is_delete && (
          <Col xs={1}>
            <Button 
              variant="icon"
              size="sm"
              title="Delete User Group"
              data-tooltip-id="pv-tooltip"
              data-tooltip-content="Delete User Group"
              onClick={() => deleteFunction(user_id)}
            >
              <Icon className="ficon-x" />
            </Button>
          </Col>
        )}
      </Row>;
      })}
    </div>
  </div>;
}

export default React.memo(CSVInvitesDisplayComponent);